import { css } from '@emotion/react';
import { tokens } from '../tokens';
import { overlayEnter, overlayExit } from './keyframes';
const overlayStaticStyle = css({
    alignItems: 'center',
    backgroundColor: tokens.colors.navy70,
    display: 'flex',
    justifyContent: 'center',
    opacity: 0,
    padding: tokens.spacing.medium,
    zIndex: tokens.zIndex.overlay,
});
export function overlayStyle({ isVisible }) {
    return [
        overlayStaticStyle,
        css({
            animation: `${isVisible ? overlayEnter : overlayExit} 200ms ease-out forwards`,
        }),
    ];
}
